import { Component, OnInit } from '@angular/core';
import { WeekDay } from '@angular/common';

import * as moment from 'moment';

import { ShiftBlockService } from 'src/shared/services/shift-block.service';
import { ShiftBlock } from 'src/shared/models/shift-block.model';
import { CostCenterService } from 'src/shared/services/cost-center.service';
import { ActivatedRoute } from '@angular/router';
import { CostCenter } from 'src/shared/models/cost-center.model';
import { Constants } from 'src/shared/utilities/constants.util';

@Component({
  selector: 'smt-shift-block-select',
  templateUrl: './shift-block-select.component.html',
  styleUrls: ['./shift-block-select.component.scss']
})
export class ShiftBlockSelectComponent implements OnInit {
  public costCenter: CostCenter;
  public startHour: number;
  public date = moment().format('YYYY-MM-DD');
  public list = [] as ShiftBlock[];
  public loading: boolean;
  public listLoading: boolean;
  public dateDescription: string;
  public lastShiftBlockId: number;

  constructor(
    public service: ShiftBlockService, 
    public costCenterService: CostCenterService,
    public route: ActivatedRoute) { }

  ngOnInit() {
    this.loading = true;
    this.listLoading = true;

    this.route.paramMap.subscribe((params) => {
      if (params.has('cost_center')) {
        const costCenterId = +params.get('cost_center');
        this.costCenterService.getCostCenter(costCenterId).then((costCenter: CostCenter) => {
          this.costCenter = costCenter;
          this.loading = false;
          this.updateDate();
        });
      }
    })
  }

  updateDate(date?: string){
    let format = 'YYYY-MM-DD';
    date = moment(date).format(format) || moment().format(format);
    
    let dateString = moment(date).format("dddd - MMM DD, YYYY");
    let dateDesc = dateString;

    if (date == moment().format(format)){
      dateDesc = 'Today (' + dateString + ')';
    }

    return this.updateShiftBlocks(date).then(() => {
      this.dateDescription = dateDesc;
      this.date = date;
    });
  }

  updateShiftBlocks(date: string){
    this.listLoading = true;
    this.list = [];

    return this.service.loadList(this.costCenter.id, moment(date).format(Constants.FacilityTimeFormat))
      .then(list => {
        this.list = list;
        if(list.length > 0){
           this.lastShiftBlockId = list[list.length -1].id;
        }
        this.listLoading = false;
      });
  }

  shortTime(hour: number) : string {
    //this is a dumy date, real dates for DayLight Savings messed up the times
    //all we need is the formated hour info so the date itself doesn't matter
    return moment('2021-01-01').hour(hour).minutes(0).seconds(0).format("h:mm a");
  }

  format(shiftBlock: ShiftBlock) : string {
    return `${this.shortTime(shiftBlock.startHour)} - ${this.shortTime(shiftBlock.endHour)}`;
  }

    queryParams(shiftBlock: ShiftBlock) {
      // You cannot use moment.add() to add the hours here, because it gets the wrong value when DST changes
      // We don't want to add hours to midnight, we want to set it to a specific time
      // For example, 2020-11-01T01:00:00 + 4 hours gets changed to 2020-11-01T04:00:00, 
      // not 2020-11-01T05:00:00 which is technically correct, but not what we want
      let date = moment(this.date).format('YYYY-MM-DD');
      let hoursToAdd = shiftBlock.startHour < 10 ? "0" + shiftBlock.startHour : shiftBlock.startHour;
      date += "T" + hoursToAdd + ":00:00";

      return {
          date: date,
          shiftBlockId: shiftBlock.id,
          costCenterId: shiftBlock.costCenterId,
          isLastShiftBlock: shiftBlock.id == this.lastShiftBlockId
      };
    }

    getBlockStatusIcon(shiftBlock: ShiftBlock): string {    
       // IsMissedblock :- true (missed),  false (completed ) , null (current and future blocks)

      if(shiftBlock.isMissedBlock==null)
        return "";

        return shiftBlock.isMissedBlock ? "icon warning icon-warning2" : "icon warning success icon-checkmark";
    }

    routerLink() {
        return ['/workflow/planner/'];
    }
}
